import { Component } from '@angular/core';

@Component({
  selector: 'black-vision-section',
  templateUrl: './vision-section.component.html',
  styleUrls: ['./vision-section.component.css'],
  standalone: true,
  imports: [],
})
export class VisionSectionComponent {}